
import { UserCog, User } from 'lucide-react';
import { Badge } from "@/components/ui/badge";

interface EventRoleBadgeProps {
  isHost: boolean;
  rsvpStatus?: 'invited' | 'accepted' | 'declined' | 'maybe';
}

export const EventRoleBadge = ({ isHost, rsvpStatus }: EventRoleBadgeProps) => {
  if (isHost) {
    return (
      <Badge variant="secondary" className="flex items-center gap-1 bg-blue-100 text-blue-800">
        <UserCog className="h-3 w-3" />
        <span>Host</span>
      </Badge>
    );
  }
  
  if (!rsvpStatus || rsvpStatus === 'invited') {
    return (
      <Badge variant="outline" className="flex items-center gap-1 bg-yellow-50 text-yellow-800 border-yellow-200">
        <User className="h-3 w-3" />
        <span>Guest</span>
      </Badge>
    );
  }
  
  // Removed the "Going" badge case to avoid duplication
  
  if (rsvpStatus === 'declined') {
    return (
      <Badge variant="outline" className="flex items-center gap-1 bg-red-50 text-red-800 border-red-200">
        <User className="h-3 w-3" />
        <span>Declined</span>
      </Badge>
    );
  }
  
  if (rsvpStatus === 'maybe') {
    return (
      <Badge variant="outline" className="flex items-center gap-1 bg-gray-50 text-gray-800 border-gray-200">
        <User className="h-3 w-3" />
        <span>Maybe</span>
      </Badge>
    );
  }
  
  // If we reach here (rsvpStatus is 'accepted'), return null
  return null;
}
